export const HtmlToText = (html = '') => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent;
};

export const getElementStringFromHtmlString = (html, selector) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.querySelector(selector)?.outerHTML || '';
};
